import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Lakeville",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of Lakeville Minnesota south metro suburban cityscape with Heritage Commons retail area, Antlers Park waterfront, pristine suburban neighborhoods surrounded by Minnesota lakes and green landscape, Dakota County skyline at dusk, warm golden hour lighting, clean professional photography, no readable text or signs",
  heroImageSeq: "lakeville-mn-hero",
  heroDescription:
    "Business trip abroad in two weeks? Family cruise to the Caribbean and your passport just expired? Need a first-time passport before a big international trip? We help Lakeville residents — from Heritage Commons families to professionals commuting to the Twin Cities — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  geoPosition: "44.6496; -93.2427",
  geoPlacename: "Lakeville, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/lakeville/",
  localAreaTitle: "Serving Lakeville & South Dakota County",
  localAreaText: [
    "Lakeville, Minnesota is one of the fastest-growing cities in Dakota County and consistently ranks as one of the best places to raise a family in Minnesota. Located at the southern edge of the Twin Cities metro on I-35 about 25 miles from Minneapolis, Lakeville combines top-rated schools, a strong community identity, and rapid residential growth. The city's population skews heavily toward young families and upper-income professionals who commute to corporate jobs throughout the metro — and who travel internationally for both business and leisure.",
    "Lakeville's south metro position provides excellent MSP Airport access via I-35 — typically 20–30 minutes to Terminal 1 or Terminal 2. Business professionals in Lakeville make this drive regularly for international departures: a project manager heading to a European client site, a financial services professional flying to Toronto, or a healthcare executive attending an international conference. When these travelers discover passport issues — expired documents, damaged covers, name changes after recent marriages — the clock ticks quickly against non-refundable flight bookings.",
    "Family travel is the dominant passport urgency driver in Lakeville. The city's family-oriented culture and high household incomes generate significant leisure travel — Caribbean cruises, European summer tours, and spring break resort packages. With children making up a large share of the population, child passport expirations (valid only 5 years) create a recurring urgency pattern. Fast Passport Center serves Lakeville's active traveler community with professional service, dedicated agents, and processing as fast as 24 hours through our reserved State Department courier access.",
  ],
  nearbyCities: [
    { name: "Lakeville", zips: "55044" },
    { name: "Burnsville", zips: "55306, 55337" },
    { name: "Apple Valley", zips: "55124" },
    { name: "Farmington", zips: "55024" },
    { name: "Rosemount", zips: "55068" },
    { name: "Prior Lake", zips: "55372" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Lakeville home or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping from any Dakota County UPS/FedEx. We handle the rest.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "We review every application before submission to prevent errors that cause rejections.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Our reserved passport agency slots mean no scrambling for public appointments.",
    },
  ],
  serviceAreaTitle: "Lakeville & South Dakota County Coverage",
  serviceAreaDescription: "Serving Lakeville and south Dakota County communities via overnight shipping",
  faqs: [
    {
      q: "How fast can I get a passport in Lakeville, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours for true emergencies. Standard government processing through a Lakeville post office can take 2–6 months. For Lakeville families with cruise departures and business travelers with upcoming international trips, the standard timeline simply does not work.",
    },
    {
      q: "Is there a passport acceptance facility in Lakeville?",
      a: "Yes — the Lakeville Post Office on Kenrick Avenue accepts passport applications by appointment. Apple Valley and Burnsville post offices are nearby alternatives. We provide guidance on which facility is best for your situation and what to expect at each location.",
    },
    {
      q: "Can I expedite a family of four passports for a Caribbean cruise?",
      a: "Yes — we handle multi-applicant families regularly. Each family member needs their own order, but we coordinate them to align on the same processing timeline so everyone's passport arrives before the cruise departs. Child passports (under 16) require an in-person acceptance clerk visit.",
    },
    {
      q: "What if my passport was just damaged — can I get a replacement quickly?",
      a: "Yes. A damaged passport must be replaced — airlines often reject damaged travel documents. We process expedited damaged passport replacements for Lakeville residents. The process is similar to a new passport application and typically requires an in-person acceptance clerk visit.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Lakeville travelers start online and ship their documents overnight. There is no local Fast Passport Center office. Start online, use the personalized checklist, and ship from the nearest UPS, FedEx, or post office in the south metro.",
    },
    {
      q: "I recently got married and changed my name — can I expedite a passport name change?",
      a: "Yes. If your passport was issued less than a year ago, you can use a DS-5504 form with your marriage certificate. If it was issued more than a year ago, you apply for a new passport. We guide Lakeville residents through the exact process for their situation and review all documentation before submission.",
    },
  ],
  testimonials: [
    {
      name: "Chris and Amy D.",
      location: "Lakeville, MN",
      rating: 5,
      text: "We were taking our three kids on a Caribbean cruise and realized two weeks before departure that our youngest's passport had expired. Fast Passport Center guided us through the child passport process, reviewed everything, and we had her passport in six business days. We made the cruise and it was incredible. Saved our family vacation.",
      service: "Child Passport",
    },
    {
      name: "Brian H.",
      location: "Heritage Commons Area, Lakeville",
      rating: 5,
      text: "I got assigned to a client project in London with twelve days notice. My passport expired two years ago. Fast Passport Center had my renewal processed in four business days. I made my flight, the project went well, and my clients never knew I almost had a passport disaster. Professional and fast.",
      service: "Passport Renewal",
    },
    {
      name: "Rachel K.",
      location: "South Lakeville, MN",
      rating: 5,
      text: "I got married last spring and needed my passport updated with my new name before a honeymoon trip to Europe. Fast Passport Center walked me through the name change process, what documents I needed, and had my new passport ready in eight business days. Our European honeymoon was perfect.",
      service: "Name Change Passport",
    },
  ],
  nearbyLinks: [
    { name: "Minneapolis", href: "/minneapolis" },
    { name: "Burnsville", href: "/burnsville" },
    { name: "Eagan", href: "/eagan" },
    { name: "Bloomington", href: "/bloomington" },
    { name: "Apple Valley", href: "/minnesota" },
    { name: "Rosemount", href: "/minnesota" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Lakeville",
  introDescription: "Fast, reliable passport processing for Lakeville and south Dakota County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than the application. Here are Lakeville and south metro resources to help you gather everything needed before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Lakeville Post Office",
      address: "20575 Kenrick Ave, Lakeville, MN 55044",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(952) 469-5491",
      notes: "Primary passport acceptance facility for Lakeville. Appointment required. Photos available. Call ahead — appointment slots fill up during spring and summer travel seasons.",
    },
    {
      name: "Apple Valley Post Office",
      address: "14700 Cedar Ave, Apple Valley, MN 55124",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 432-6120",
      notes: "North Lakeville alternative. Passport photos available. Appointment recommended.",
    },
    {
      name: "Burnsville Post Office",
      address: "12 Burnsville Center, Burnsville, MN 55306",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 890-2610",
      notes: "Northwest alternative for Lakeville residents near the Burnsville border.",
    },
    {
      name: "Farmington Post Office",
      address: "508 3rd St, Farmington, MN 55024",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 463-4781",
      notes: "Southeast option for Lakeville residents near Farmington. Smaller facility — call ahead for availability.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Lakeville", address: "16899 Kenyon Ave, Lakeville, MN 55044", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Lakeville", address: "17295 Kenyon Ave, Lakeville, MN 55044", hours: "Call for hours" },
    { name: "Target — Lakeville", address: "17780 Kenwood Trl, Lakeville, MN 55044", hours: "Daily 8 AM – 10 PM" },
    { name: "The UPS Store — Apple Valley", address: "Apple Valley area, MN 55124", hours: "Call for hours" },
    { name: "Walgreens — Apple Valley", address: "14250 Cedar Ave, Apple Valley, MN 55124", hours: "Call for hours" },
    { name: "CVS Pharmacy — Burnsville", address: "14601 Grand Ave S, Burnsville, MN 55306", hours: "Daily 7 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Dakota County Driver and Vehicle Services — Lakeville",
      address: "Lakeville area service center, Dakota County",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Driver licenses, REAL ID, titles & registration. Online appointment scheduling required for most services.",
      featured: true,
    },
    {
      name: "Dakota County Government Center — Hastings",
      address: "1590 Highway 55, Hastings, MN 55033",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Dakota County seat option for southeast Lakeville and Rosemount residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 22 miles from Lakeville — 25 minutes via I-35",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Lakeville's direct I-35 access makes MSP highly convenient. Nonstop international service to Amsterdam, London, Paris, Tokyo, and Reykjavik. Many Lakeville residents commute to MSP for both business and leisure international departures.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "Rochester, MN — about 65 miles south on I-35",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Secondary regional option for Lakeville travelers with direct Rochester connections. Primarily used for domestic travel and medical appointments.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "I-35 Direct to MSP",
      subtitle: "Lakeville's straight-shot highway connection to international departures",
      content:
        "Lakeville's position on I-35 provides one of the most direct routes to MSP Airport in the south metro. The 20–25 minute drive north on I-35 deposits Lakeville travelers directly at the airport's terminal area. This geographic advantage means Lakeville residents travel internationally frequently — and the closeness creates urgency when passport issues are discovered before departure.",
      tip: "I-35 to MSP from Lakeville is typically 20–25 minutes outside rush hour. Account for morning peak traffic (7–9 AM) when planning airport departure timing.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "Family Travel",
      subtitle: "Lakeville's family-first culture and international leisure travel",
      content:
        "Lakeville is one of the most family-oriented cities in Minnesota. With excellent schools and strong community bonds, families take international trips together — Caribbean cruises for spring break, European summer tours, and Mexico resort vacations. The challenge: children's passports expire after just 5 years, creating regular expiration surprises at the worst possible times.",
      tip: "Lakeville families should do a passport audit every fall before spring break travel planning begins. Check expiration for every family member — adults and children alike.",
      icon: "ri-parent-line",
    },
    {
      title: "Twin Cities Commuter Professional Travel",
      subtitle: "Lakeville professionals commuting to corporate jobs throughout the metro",
      content:
        "Many Lakeville residents commute to major employers across the Twin Cities — medical device companies in Eden Prairie, financial services firms in Minneapolis, and technology companies throughout the I-494 corridor. These professionals regularly receive international travel assignments on short notice, making passport readiness essential.",
      tip: "If you commute to a company with international operations, keep your passport valid with at least 12 months remaining. Check it every January as a simple annual habit.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Minnesota Lake Country & Canadian Fishing",
      subtitle: "Boundary Waters and Ontario trip travel documents",
      content:
        "Lakeville's outdoor-oriented culture means many residents travel to the Boundary Waters and beyond — including Canadian fishing and hunting trips in Ontario. International travel to Canada by air requires passports for all family members including children. The summer season creates a recurring passport check urgency for lake cabin and fishing trip travelers.",
      tip: "All international travel — including air travel to Canada — requires valid passports for everyone in your party. Check documents in May before summer fishing season begins.",
      icon: "ri-water-flash-line",
    },
  ],
  destinations: [
    {
      name: "Caribbean",
      context: "Family cruises, resort packages, and spring break from MSP",
      urgency: "Spring break creates peak passport demand — January and February are critical processing months",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Cancun and Puerto Vallarta vacations for Lakeville families",
      urgency: "Last-minute resort deals create 2–3 week booking windows that standard processing cannot meet",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "Business meetings, corporate travel, and MSP direct flights to London",
      urgency: "Corporate travel typically arrives with 10–21 days notice for Lakeville professionals",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Ontario fishing, Winnipeg visits, and border crossing travel",
      urgency: "Summer fishing season peak runs May through September for Lakeville outdoor enthusiasts",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Netherlands",
      context: "MSP direct to Amsterdam and European tour connections for Minnesota families",
      urgency: "Summer European travel season creates a compressed booking window in January–March",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Italy",
      context: "European summer tours, Mediterranean cruises, and heritage tourism",
      urgency: "European summer trip bookings in January–March require passports well before June departures",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "Top 10",
      label: "Lakeville consistently ranks among the best places to raise a family in Minnesota",
    },
    {
      stat: "22 Miles",
      label: "Lakeville to MSP Airport via I-35 — efficient south metro access to international departures",
    },
    {
      stat: "Mar–Aug",
      label: "peak season for Lakeville passport urgencies — spring break through summer cruise season",
    },
    {
      stat: "24 Hours",
      label: "fastest emergency turnaround for Lakeville travelers with urgent international departures",
    },
  ],
};

export default function LakevillePage() {
  return <CityPage data={data} />;
}